// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__1Y6yg","radioRow":"SimpleQuestionBuilderModal_radioRow__wVZW9"};